module.exports = __webpack_public_path__ + "img/baozheng.4cbeea2c.jpg";